import React, { FC, useState } from 'react'
import { RefreshCcw } from 'lucide-react'
import { format } from 'date-fns'

import { Button } from '../../../components/ui/button'

import { cn } from '../../../lib/utils'

interface ManageTotalsActionsProps {
  getTotals: () => Promise<void>
}

export const ManageTotalsActions: FC<ManageTotalsActionsProps> = ({ getTotals }) => {
  const [buttonLoading, setButtonLoading] = useState(false)
  const [date, setDate] = useState('Now')

  const onUpdate = async () => {
    setButtonLoading(true)
    await getTotals().then()
    setDate(format(new Date(), 'h:mm a, dd MMM'))
    setButtonLoading(false)
  }

  return (
    <div className="ml-auto flex justify-end max-w-full">
      <div className="flex gap-2 items-center text-right">
        <p>Correct as of {date}</p>
        <Button
          disabled={buttonLoading}
          type="button"
          variant="light"
          onClick={onUpdate}
          className="h-[38px] w-[38px]"
        >
          <RefreshCcw className={cn('w-3', buttonLoading && 'animate-spin')} />
        </Button>
      </div>
    </div>
  )
}
